// Generated by scripts/icons/build-icon-components.mjs from the matching
// file in ./svg — edit the SVG and re-run the script, not this file.
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

const UploadIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <g fill="currentColor">
      <path
        d="M1.9 13.19c0-2.41 1.96-4.36 4.37-4.36h11.46c2.4 0 4.36 1.95 4.36 4.36v4.95c0 2.4-1.95 4.36-4.36 4.36H6.27c-2.4 0-4.36-1.95-4.36-4.36z"
        opacity=".5"
      />
      <path d="m12.82 4.3 1.61 1.62c.32.31.83.31 1.16 0 .32-.32.32-.84 0-1.16l-3.01-3.02q-.08-.08-.18-.13V1.6l-.1-.05q-.12-.05-.28-.05h-.04q-.15 0-.29.05l-.17.1-.1.09-3 3.02c-.33.32-.33.84 0 1.16.32.31.83.31 1.16 0l1.6-1.62v11.3c0 .45.37.81.82.81s.82-.36.82-.82z" />
    </g>
  </SvgIcon>
);

export default UploadIcon;
